// Comprehensive ResizeObserver error suppression
// Must be loaded before React Dev Tools error overlay

// Suppress in console
const suppressConsoleError = () => {
  const originalError = console.error;
  console.error = function filterWarnings(...args) {
    const firstArg = args[0];
    if (
      typeof firstArg === 'string' &&
      (firstArg.includes('ResizeObserver loop limit exceeded') ||
       firstArg.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };
};

// Suppress window errors
const suppressWindowError = () => {
  window.addEventListener('error', (e) => {
    if (
      e.message &&
      (e.message.includes('ResizeObserver loop limit exceeded') ||
       e.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true); // Use capture phase to catch early
};

// Initialize suppressors immediately
suppressConsoleError();
suppressWindowError();

export { suppressConsoleError, suppressWindowError };
